// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f9ba9c20","977":"e7e55c97"}[chunkId] + ".chunk.js";
};